'use strict';

yalwa.accounts = (function(pub) {
	pub = pub || {};

	let first_name;
	let last_name;
	let birthday;
	let form;
	let company_name;
	let tax_id;
	let about_text;
	let imprint_text;
	let mapStreet;
	let mapZip;
	let mapCity;
	let website;

	pub.init = function() {
		switch (yalwa.basics.get_routing()) {
			case 'myratings':
				init_myratings();
				break;
			case 'notification-center':	
			case 'settings':
				init_settings();
				break;
			case 'start_logged_in':
			case 'start':
				init_start();
				break;
			case 'myinvoices':
				init_invoices();
				break;
		}
		yalwa.mobile.ali.init();
		yalwa.basics.load_js(yalwa.basics.static_url('js') + 'mobile/phone_verification_generic.js');

		jQuery('.js-close_phone_verify_promo').on('click', function() {
			yalwa.basics.hide(jQuery('.js-phone_verified_promo'));
			yalwa.basics.set_cookie('no_verification_popup', true, 86400 * 30);
		});

		jQuery('.js-oninvalid_fix')
			.on('invalid', function(e) {
				e.preventDefault();
				const $e = jQuery('.js-oninvalid_fix__error_msg');
				$e.html(e.target.validationMessage);
				yalwa.basics.show($e);
				jQuery(this).closest('.js-oninvalid_fix_container').find('.js-oninvalid_fix_label').css('transition', 'inherit').velocity('callout.shake');

			})
			.on('change', function(e) {
				e.preventDefault();
				jQuery('.js-oninvalid_fix__error_msg').html('');
				yalwa.basics.hide(jQuery('.js-oninvalid_fix__error_msg'));

			});

		yalwa.basics.webpush.not_available_info();
		
		//check the saved alert, add the class to the alert where user came from
		jQuery('.js-manage_abo').find('.js-manage_abo_item').each(function (i, e){
			var abo_search = jQuery(e).attr('data-searchid');
			if (window.location.href.indexOf(abo_search) !== -1) {
				jQuery(e).addClass('abo-border-green');
			}
		});

		jQuery(document).on('click', '.js-vip_renew', function(e) {
			e.preventDefault();
			const featureID = jQuery(this).data('featureid') || 26;
			const touchpointID = 'profile_vip_renewal';
			let orders = [];
			let touchpoints = [];
			orders[0] = {};
			orders[0][featureID] = 1;
			touchpoints[0] = {};
			touchpoints[0][featureID] = touchpointID;
			jQuery.ajax({
				url: yalwa.v.checkout_base,
				type: 'POST',
				crossDomain: true,
				dataType: 'json',
				data: {
					action: 'uhp',
					userID: yalwa.v.userID,
					countryID: yalwa.v.countryID,
					currency_code: yalwa.v.currency_code,
					orders: orders,
					touchpoints: touchpoints
				}
			}).done(function(response) {
				if (response.success && response.redirect_url) {
					window.location.href = response.redirect_url;
				}
			});
		});
	};
	
	function init_invoices() {
		jQuery(".js-select_invoices_year").on('change', function() {
			jQuery(this).closest('form').submit();
		});
	}

	function init_start() {
		jQuery('.js-odr_plp a').on('click', function() {
			yalwa.basics.ls_set('hide_odr_box', 1);
		});
		if (!yalwa.basics.ls_get('hide_odr_box')) {
			yalwa.basics.show(jQuery('.js-odr_plp'));
		}
		jQuery('.js-mlstart__show_details').on('click', function() {
			yalwa.basics.toggle(jQuery('.js-mlstart_followers__details'));
		});
		if (jQuery('.js-uhp_promo_overlay__close').length) {
			yalwa.mobile.generic_shadow.show();
			jQuery(document).on('generic_shadow_hide', function() {
				jQuery('.js-uhp_promo_overlay__close').trigger('click');
			});
			jQuery('.js-uhp_promo_overlay__close').on('click', function() {
				yalwa.basics.set_cookie('no_user_hp_promo', true, 86400 * 7);
				jQuery('.js-uhp_promo_overlay').remove();
				yalwa.mobile.generic_shadow.hide();
			});
		}
		jQuery('.js-start_logged_in_vip__link').on('click', function(event) {
			const url = jQuery(event.target).closest('a').attr('href');
			yalwa.basics.ga.event({
				category: 'VIP Invite',
				action: 'Banner Learn More Button',
				label: 'mobile',
			}).done(() => {
				yalwa.basics.navigate(url);
			});
			return false;
		});
	}

	function init_settings() {
		init_settings_tabs();
		add_settings_tab_handlers();
		init_notifications_settings();
		if (yalwa.basics.get_get('success')) {
			yalwa.basics.set_get({'success': null}, false, false);
		}
		if (jQuery('.js-profile_fileupload').length) {
			yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/fileupload.js', init_profile_picture_upload);
		}
		jQuery('.js-profile_settings_form').on('click', '.js-phone_remove', phone_remove);
		jQuery('.js-phone_add_submit').on('click', phone_submit);
		jQuery('.js-phone_add').on('click', phone_add);
		jQuery('.js-phone_add_cancel').on('click', phone_add_cancel);
		if (!yalwa.v.is_standalone) {
			jQuery('.js-profile_nickname')
				.on('keypress', nickname_keypress)
				.on('blur', nickname_check);
		}
		if (jQuery('.js-fill_address').length) {
			jQuery(document).on('geolocation_success.my_fill_address', function(event, position) {
				geolocation_profile_address(position.coords.latitude, position.coords.longitude);
			});
			jQuery('.js-fill_address').on('click', function() {
				yalwa.mobile.get_current_position(5000, 'my_fill_address');
			});
		}
		jQuery('.js-hybrid_warning_settings').on('focus', function() {
			jQuery(this).data('value_before', this.value);
		});
		jQuery('textarea[name="imprint"]').bind('input propertychange', function() {
			jQuery('#edit_imprint_hidden').attr('value', '1');
		});

		yalwa.basics.load_js(yalwa.basics.static_url('js') + 'external/quickselect.js', function() {
			jQuery('.js-profile_settings_sex').quickselect({
				breakOut: 'all',
				activeIsDeletable: false
			});
			yalwa.mobile.stop_invisible_start();
		});
		if (window.location.hash && jQuery(window.location.hash).length) {
			setTimeout(function() {
				jQuery('.js-main_col')
					.scrollTop(0)
					.scrollTop(jQuery(location.hash).offset().top - jQuery('.js-headroom').height());
			}, 400); // doesn't work for ios without timeout
		}
		jQuery('.js-htab_public').on('htabs_show_done', profile_img_animate);
		profile_img_animate();


		jQuery('.js-save_settings').on('click', settings_save);
		
	}

	const add_settings_tab_handlers = () => {
		jQuery('.js-account_general_changes').on('change', () => {
			yalwa.basics.show(jQuery('.js-account_general_changes_buttonbar'));
		});
		jQuery('.js-account_general_changes').on('keydown', () => {
			yalwa.basics.show(jQuery('.js-account_general_changes_buttonbar'));
		});

		jQuery('.js-account_user_type_changes').on('change', () => {
			yalwa.basics.show(jQuery('.js-account_user_type_changes_buttonbar'));
		});

		jQuery('.js-account_user_type_changes').on('keydown', () => {
			yalwa.basics.show(jQuery('.js-account_user_type_changes_buttonbar'));
		});

		jQuery('.js-about_text').on('keydown', function() {
			yalwa.basics.show(jQuery(this).parents('.my_input__bordered').find('.js-button_bar'));
		});

		jQuery('.js-imprint_text').on('keydown', function() {
			yalwa.basics.show(jQuery(this).parents('.my_input__bordered').find('.js-button_bar'));
		});

		jQuery('.js-account_contact_changes').on('change', () => {
			yalwa.basics.show(jQuery('.js-account_contact_changes_buttonbar'));
		});
		jQuery('.js-account_contact_changes').on('keydown', () => {
			yalwa.basics.show(jQuery('.js-account_contact_changes_buttonbar'));
		});

		write_defaults();

		jQuery('.js-cancel_reload[data-target="default"]').on('click', () => {
			jQuery('[name="sex"][value="'+form+'"]').trigger('click');
			jQuery('[name="given_name"]').val(first_name);
			jQuery('[name="name"]').val(last_name);
			jQuery('[name="birthday"]').val(birthday);
			jQuery('.my_input--required').removeClass('my_input--required');
			yalwa.basics.hide(jQuery('.js-account_general_changes_buttonbar'));
		});

		jQuery('.js-cancel_reload[data-target="contact"]').on('click', () => {
			jQuery('[name="mapStreet"]').val(mapStreet);
			jQuery('[name="mapZip"]').val(mapZip);
			jQuery('[name="mapCity"]').val(mapCity);
			jQuery('[name="website"]').val(website);
			yalwa.basics.hide(jQuery('.js-account_contact_changes_buttonbar'));
		});

		jQuery('.js-cancel_reload[data-target="about"]').on('click', function() {
			jQuery('[name="about"]').val(about_text);
			yalwa.basics.hide(jQuery(this).parent());
		});

		jQuery('.js-cancel_reload[data-target="imprint"]').on('click', function() {
			jQuery('[name="imprint"]').val(imprint_text);
			yalwa.basics.hide(jQuery(this).parent());
		});

		jQuery('[name="show_odr_link"]').on('change', settings_save);
		jQuery('[name="share_favorites"]').on('change', settings_save);
		jQuery('[name="twofactor_enabled"]').on('click', async (e) => {
			e.preventDefault();
			let load_js = yalwa.basics.import_js('shared/web_components/twofactor.js');
			if (jQuery('[name="twofactor_enabled"]').prop('checked')) {
				await load_js;
				jQuery('yalwa-twofactordialog')[0].request_action(jQuery('yalwa-twofactordialog').attr('step') || 'start');
				jQuery(document).on_once('twofactor-enabled.activate_plp', async function(e) {
					await load_js;
					const $input = jQuery('[name="twofactor_enabled"]');
					$input.prop('checked', true);
					checkbox_toggle($input);
					yalwa.basics.show(jQuery('.js-twofactor_trusted_section'));
					yalwa.basics.hide(jQuery('.js-twofactor_disabled_msg'));
					jQuery('.js-twofactor_activate_success_plp')[0].show_modal();
					if (e.originalEvent.detail.type === 'email') {
						jQuery('yalwa-twofactordialog')[0].track('email_verification', 'email_code_verified', 'email');
					}
				});
			} else {
				jQuery('.js-twofactor_deactivate_plp').on_once('plp_cancel.deactivate_plp', async (e) => {
					await load_js;
					jQuery('yalwa-twofactordialog')[0].request_action('code');
					jQuery(document).on_once('twofactor-code-submitted.login', 'yalwa-twofactordialog', async function(event) {
						const response = await yalwa.basics.ajaxservice({
							type: 'POST',
							resource: 'twofactor',
							action: 'disable',
							data: {otp_token: event.originalEvent.detail.code || event.originalEvent.detail.backup_code},
							csrf: yalwa.v.csrf_twofactor.disable,
							dating_specific: false
						});
						if (response.success) {
							jQuery('yalwa-twofactordialog')[0].close();
							const $input = jQuery('[name="twofactor_enabled"]');
							$input.prop('checked', false);
							checkbox_toggle($input);
							yalwa.basics.hide(jQuery('.js-twofactor_trusted_section'));
							yalwa.basics.show(jQuery('.js-twofactor_disabled_msg'))
							jQuery('.js-twofactor_deactivate_success_plp')[0].show_modal();
						} else {
							jQuery('yalwa-twofactordialog')[0].show_invalid();
						}
					});
				})[0].show_modal();
				jQuery(document).on_once('twofactor-dialog-closed.deactivate_plp', 'yalwa-twofactordialog', function() {
					jQuery('.js-twofactor_deactivate_plp').off('plp_cancel.deactivate_plp');
				});
				
			}
		});
		jQuery('.js-twofactor_clear_remembered').on('click', () => {
			jQuery('.js-twofactor_clear_remembered_plp').on('plp_confirm', async () => {
				const response = await yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'twofactor',
					action: 'clear_remembered',
					csrf: yalwa.v.csrf_twofactor.clear_remembered,
				});
				if (response.success) {
					yalwa.basics.reload();
				}
			})[0].show_modal();
		})
		jQuery('[name="share_ads[]"]').on('change', settings_save);
		jQuery('.js-tfa_promo_cta').on('click', async (e) => {
			jQuery('.js-settings__tabs_item[data-site="security"]').trigger('click');
			jQuery(e.target).closest('yalwa-dialog')[0].close();
			yalwa.basics.ga.datalayer({
				event: 'fa_on_site_promo_click',
				'2fa_on_site_promo_click_touchpoint': '2fa_promo_plp'
			});
		})
	}

	function checkbox_toggle($input) {
		const $t = $input.siblings('.js-checkbox_text_before');
		const tmp = $t.data('toggle_text');
		$t.data('toggle_text',$t.text());
		$t.text(tmp);
	}
	
	const init_settings_tabs = () => {
		jQuery('.js-settings__tabs_item').on('click', function() {
			const $this = jQuery(this);
			const site = $this.data('site');
			
			yalwa.basics.hide(jQuery('.js-settings_tab'));
			yalwa.basics.show(jQuery('.js-settings_tab[data-section="' + site + '"'));
			jQuery('.settings__tabs_item_active').removeClass('settings__tabs_item_active');
			$this.addClass('settings__tabs_item_active');
			yalwa.basics.set_get({tab: site === 'default' ? null : site});
		});
	}

	function phone_remove() {
		var $this = jQuery(this);
		jQuery.post(
			'/api/ajax/phone_remove',
			{
				number: jQuery.trim($this.data('number'))
			},
			function(response) {
				if (response.success) {
					jQuery('.js-phone_entry[data-number=' + response.number + ']').remove();
				} else {
					jQuery('.js-phone_entry').find('.js-phone_remove').remove();
				}
				update_numbers_visibility();
			},
			'json'
		);
	}

	function phone_add() {
		yalwa.basics.hide(jQuery('.js-no_numbers_saved'));
		yalwa.basics.show(jQuery('.js-phone_add_input'));
		jQuery('.js-phone_add_number').val('').trigger('input');
	}

	function phone_add_cancel() {
		if (jQuery('.js-settings_numbers li').length === 0) {
			yalwa.basics.show(jQuery('.js-no_numbers_saved'));
		}		
		yalwa.basics.hide(jQuery('.js-phone_add_input'));
	}

	pub.phone_submit_request = function(calling_codeID, phone_number) {
		return jQuery.ajax({
			url: '/api/ajax/phone_add',
			type: 'post',
			data: {
				calling_codeID,
				phone_number
			},
			dataType: 'json'
		});
	}
	
	function phone_submit() {
		pub.phone_submit_request(jQuery('.js-phone_add_calling_codeID').val(), jQuery('.js-phone_add_number').val()).done(submit_response);
	}

	function submit_response(response) {
		if (response.success) {
			jQuery('.js-settings_numbers').append(response.new_row);
			yalwa.basics.hide(jQuery('.js-phone_add_input'));
			yalwa.basics.show(jQuery('.js-phone_add'));
			update_numbers_visibility();
		} else {
			if (window.toastr) {
				window.toastr.remove();
			}
			yalwa.basics.toast({message: response.error, type: 'error'});
		}
	}

	function update_numbers_visibility() {
		if (jQuery('.js-settings_numbers li').length) {
			yalwa.basics.show(jQuery('.js-settings_numbers'));
			yalwa.basics.hide(jQuery('.js-no_numbers_saved'));
		} else {
			yalwa.basics.hide(jQuery('.js-settings_numbers'));
			yalwa.basics.show(jQuery('.js-no_numbers_saved'));
		}
	}
	
	function remove_nickname_check() {
		jQuery('.js-profile_settings_form')
			.off('change', 'input:not(.js-change_notifications_settings),select,textarea')
			.on('change', 'input:not(.js-change_notifications_settings),select,textarea', settings_save);
		jQuery('.js-profile_nickname')
			.off('keypress')
			.off('blur');
	}

	function settings_save() {
		if (yalwa.mobile.htabs.current() === 'cordova') {
			return;
		}
		const $this = jQuery(this);
		if ($this.is('.js-phone_add_number, .js-phone_add_calling_codeID, .js-profile_nickname')) {
			return;
		}
		if ($this.hasClass('js-hybrid_warning_settings')) {
			jQuery('.js-hybrid_warning_change_settings')
				.on('click', '.js-plp_confirm', () => {
					yalwa.basics.ga.event({
						category: 'hybrid-change-warning',
						action: 'hybrid-warning-confirm',
						label: 'change-setting'
					});
					jQuery('.js-hybrid_warning_settings').removeClass('js-hybrid_warning_settings');
					jQuery('.js-hybrid_warning').trigger('plp_hide', {is_queued:true});
					settings_save();
				})
				.on('click', '.js-plp_ok', () => {
					yalwa.basics.ga.event({
						category: 'hybrid-change-warning',
						action: 'hybrid-warning-cancel',
						label: 'change-setting'
					});
					jQuery('.js-hybrid_warning').trigger('plp_hide', {is_queued:true});
					if ($this.data('value_before')) {
						$this.val($this.data('value_before'));
					}
				})
				.trigger('plp_show', {is_queued:true});
			return;
		}
		const birthday = jQuery('.js-profile_birthday').val();
		const max_year = jQuery('.js-profile_birthday').data('max_year');
		let year = '';
		let month = '';
		let day = '';
		if (birthday) {
			year = birthday.substr(0, 4);
			month = birthday.substr(5, 2);
			day = birthday.substr(8, 2);
		}
		let is_birthday_valid = birthday_valid();
		if(!is_birthday_valid.success) {
			jQuery('[name="birthday"]').parents('.my_input').addClass('my_input--required');
			switch(is_birthday_valid.reason) {
				case 'invalid_date':
					jQuery('.js-age_error').trigger('plp_show', {is_queued:true});
					break;
				case 'under_18':
					jQuery('.js-invalid_age').trigger('plp_show', {is_queued:true});
					break;
				case 'over_100':
					jQuery('.js-age_error').trigger('plp_show', {is_queued:true});
					break;
			}
			reset_settings_tabs();
			return false;
		}
		const $form = jQuery('.js-profile_settings_form');
		$form.append('<input type="hidden" max="' + max_year + '" name="year" value="' + year + '" /><input type="hidden" name="month" value="' + month + '" /><input type="hidden" name="day" value="' + day + '" />');
		$form.append('<input type="hidden" name="ht" value="' + yalwa.mobile.htabs.current() + '" />');
		jQuery('.js-profile_fileupload').prop('disabled', true); // iOS fails otherwise
		let data = new FormData($form[0]);
		if (yalwa.basics.uac_suspicious()) {
			data.append('uac_suspicious', 1);
		}
		// Toggles handled separately
		const field_name = $this.attr('name');
		if (field_name === 'show_odr_link' || field_name === 'share_favorites' || field_name === 'share_ads[]') {
			let new_data = new FormData();
			// Create a new FormData object with only the first two entries
			Array.from(data.entries()).slice(0, 2).forEach(([key, value]) => new_data.append(key, value));
			new_data.append('sub_action', 'change_toggle_data');
			if (this.name === 'share_ads[]') {
				new_data.append('share_ads_submitted', '1');
				document.querySelectorAll('input[name="share_ads[]"]:checked').forEach((el) => {
					new_data.append('share_ads[]', el.value);
				});
			} else {
				new_data.append(this.name, this.checked ? '1' : '0');
			}
			data = new_data;
		}
		jQuery('.js-profile_fileupload').prop('disabled', false);
		jQuery.ajax({
			url: location.origin + location.pathname + '?show=edit-profile',
			type: 'POST',
			processData: false,
			contentType: false,
			data: data,
			dataType: 'json',
		}).done(after_submit);
	}

	function get_entered_birthday() {
		return jQuery('.js-profile_birthday').val();
	}

	function birthday_valid() {
		var bd = get_entered_birthday();
		if (!is_valid_date(bd)) {
			return {success:false, reason:'invalid_date'};
		}
		if (calc_age(bd) < 18) {
			return {success:false, reason:'under_18'};
		}
		if (calc_age(bd) > 100) {
			return {success:false, reason:'over_100'};
		}
		return {success:true, reason: 'OK'};
	}

	function is_valid_date(d){
		const regex = /^([1-2]\d\d\d?)-(\d\d?)-([0-3]\d?)$/gm;
		const matches = regex.exec(d);
		if (!matches) {
			return false;
		}
		if (matches.length !== 4) {
			return false;
		}
		const month = matches[2];
		const day = matches[3];
		
		if (month > 12 || month < 1) {
			return false;
		}
		if (day > 31 || day < 1) {
			return false;
		}
		const date = new Date(d);
		return date instanceof Date && !isNaN(date);
	}

	function calc_age(birthday) {
		var ageDifMs = Date.now() - new Date(birthday).getTime();
		var ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}

	const reset_settings_tabs = () => {
		const $items = jQuery('.settings__tabs_item');
		const $default_tab = $items.filter('[data-site="default"]');
		$default_tab.trigger('click');
	};
	
	const reset_tabs = () => {
		const $items = jQuery('.js-htabs_item');
		const $default_tab = $items.filter('[data-sectionid="default"]');
		$default_tab.trigger('click');
	};

	let event_sent = false;
	function after_submit(r) {
		var $f = jQuery('.js-profile_settings_form');
		if (window.toastr) {
			window.toastr.clear();
		}
		if (r.errors.length) {
			if (yalwa.v.is_standalone && r.errors.length > 1) {
				yalwa.basics.toast({message: yalwa.v.lang.missing_fname_lname_nickname, type: 'warning'});
			} else {
				for (var i = 0; i < r.errors.length; i++) {
					yalwa.basics.toast({message: r.errors[i], type: 'warning'});
				}
			}

			if (!jQuery('[name="given_name"]').val()) {
				jQuery('[name="given_name"]').parents('.my_input').addClass('my_input--required');
			}

			if (!jQuery('[name="name"]').val()) {
				jQuery('[name="name"]').parents('.my_input').addClass('my_input--required');
			}


			reset_settings_tabs();
			reset_tabs();
		} else {
			jQuery('.my_input--required').removeClass('my_input--required');
			write_defaults();
			yalwa.basics.hide(jQuery('.js-account_changes_buttonbar'));
			yalwa.basics.hide(jQuery('.js-button_bar'));
			yalwa.basics.ga.pageview({page: '/profile_missing_info-profile', 'location': '/'}, 'b');
			if (yalwa.v.is_standalone) {
				yalwa.v.is_standalone = false;
				yalwa.mobile.ali.set_to_readonly(jQuery('.js-profile_nickname'));
				remove_nickname_check();
			}

			if (yalwa.basics.get_get('douplp')) {
				yalwa.basics.set_get({douplp: null});
				yalwa.basics.ga.event({
					category: 'douplp',
					action: 'finish'
				});
			}
			if (r && r.vip_completion) {
				document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: r.vip_completion}));
			}
			yalwa.basics.debounce(() => {
				yalwa.basics.toast({
					title: $f.data('label_success_title'),
					message: $f.data('label_success_body'),
					type: 'success',
					timeOut: 2000
				});
			}, 500);
		}
		
		// Checking for errors DEV-8592
		if (!event_sent) {
			event_sent = true;
		}
		
	}

	function write_defaults() {
		form = jQuery('[name="sex"]:checked').val();
		first_name = jQuery('[name="given_name"]').val();
		last_name = jQuery('[name="name"]').val();
		birthday = jQuery('[name="birthday"]').val();
		mapStreet = jQuery('[name="mapStreet"]').val();
		mapZip = jQuery('[name="mapZip"]').val();
		mapCity = jQuery('[name="mapCity"]').val();
		website = jQuery('[name="website"]').val();
		company_name = jQuery('[name="company_name"]').val();
		tax_id = jQuery('[name="tax_id"]').val();
		about_text = jQuery('.js-about_text').val();
		imprint_text = jQuery('.js-imprint_text').val();
	}

	function init_myratings() {
		jQuery('.js-my_ratings_delete').on('click', remove_rating_request);
		jQuery('.js-my_ratings__tabs_item').on('click', function(e) {
			e.preventDefault();
			const $this = jQuery(this);
			jQuery('.my_ratings__tabs_item_active').removeClass('my_ratings__tabs_item_active');
			$this.addClass('my_ratings__tabs_item_active');
			const site = $this.data('site');
			yalwa.basics.set_get({site:site});
			jQuery('.js-my_ratings_site > div').addClass('hidden');
			jQuery('.js-my_ratings_site > div[data-site="' + site + '"]').removeClass('hidden');
		});
	}

	var init_profile_picture_upload_initialized = false;
	function init_profile_picture_upload() {
		if (init_profile_picture_upload_initialized) {
			return;
		}
		init_profile_picture_upload_initialized = true;
		jQuery('.js-upload_new_pic,.js-avatar_img,.js-avatar_placeholder').on('click', function() {
			// In the android app the shared upload menu owns this click
			if (yalwa.v.is_phonegap && !yalwa.v.is_ios) {
				return;
			}
			jQuery('.js-profile_fileupload').trigger('click');
		});
		jQuery('.js-delete_profile_avatar').on('click', delete_profile_avatar);
		jQuery('.js-meta_click_all').on('click', meta_click_all);
		jQuery('.js-profile_fileupload').fileupload(jQuery.extend(yalwa.basics.upload_defaults(), {
			url: '/api/ajax/avatar_upload',
			done: upload_done
		}));
	}

	function delete_profile_avatar() {
		jQuery.post('/api/ajax/avatar_upload', {
			delete_avatar: 1
		}, function(response) {
			if (response.vip_completion) {
				document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
			}
			yalwa.basics.hide(jQuery('.js-avatar_img'));
			yalwa.basics.show(jQuery('.js-avatar_placeholder'));
			yalwa.basics.show(jQuery('.js-new_photo_upload_btn'));
			yalwa.basics.hide(jQuery('.js-edit_photo_upload_btn'));
		});
	}

	function upload_done(e, data) {
		if (data.result.errors !== '[]') {
			var err = jQuery.parseJSON(data.result.errors);
			jQuery.each(err, function(id, message) {
				yalwa.basics.toast({message: message, type: 'error'});
			});
		} else {
			// hack for reloading image (cache)
			window.setTimeout(function() {
				var $iframe = jQuery('.js-hide_reload_frame');
				for (var i = 0; i < 20; i++) {
					$iframe.attr('src', data.result.image_url);
				}
			}, 100);
			if (data.result.vip_completion) {
				document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: data.result.vip_completion}));
			}
			yalwa.basics.hide(jQuery('.js-avatar_placeholder'));
			jQuery('.js-avatar_img').attr('src', data.result.image_url);
			yalwa.basics.show(jQuery('.js-avatar_img'));
			yalwa.basics.hide(jQuery('.js-new_photo_upload_btn'));
			yalwa.basics.show(jQuery('.js-edit_photo_upload_btn'));
			profile_img_animate();
			yalwa.v.user_updates_clear_cache = true;
			yalwa.basics.toast({
				title: data.result.label_success_title,
				message: data.result.label_success_body,
				type: 'success',
				timeOut: 2000
			});
		}
	}

	function profile_img_animate() {
		jQuery('.js-avatar_img').removeClass('settings__img--regular');
		window.setTimeout(function() {
			jQuery('.js-avatar_img').addClass('settings__img--regular');
		}, 50);
	}

	function meta_click_all() {
		jQuery('.js-meta_select:not(:checked)').prop('checked', true).trigger('change');
	}

	function remove_rating_request(e) {
		e.preventDefault();
		const $this = jQuery(this);
		const reviewID = $this.data('reviewid');
		const ctrl_str = $this.data('ctrl_str');
		if (reviewID && ctrl_str) {
			jQuery.ajax({
				url: '/api/ajax/user_rating',
				data: {
					action: 'delete_rating_request',
					reviewID: reviewID,
					ctrl_str: ctrl_str
				},
				type: 'post'
			}).done(function(status) {
				if (status === 'success') {
					$this.closest('.js-my_ratings__posting').velocity('fadeOut');
					yalwa.basics.label('follower_page_follower_removed').done(function(value) {
						yalwa.basics.toast({message: value, type: 'success'});
					});
				}
			});
		}
	}

	function nickname_keypress(event) {
		if (event.keyCode === 10 || event.keyCode === 13) {
			jQuery('.js-profile_nickname').trigger('blur');
		}
	}

	function nickname_check() {
		return jQuery.ajax({
			url: '/api/ajax/nickname_check/',
			type: 'post',
			dataType: 'json',
			data: {
				nickname: jQuery('.js-profile_nickname').val()
			}
		}).done(nickname_check_response);
	}

	function nickname_check_response(response) {
		if (response[0] === true) {
			settings_save();
		} else {
			let info = response[1];
			if (!info) {
				return;
			}
			if (response[2] === 'has_illegal_chars') {
				const badChar = jQuery('.js-profile_nickname').val().match(/[^A-Za-z0-9-_àáâäœæçéèêëîïíñoöôóùúûüÿÄÖÜ]/);
				info += ': ' + badChar;
				jQuery('.js-nickname_suggestion_plp_text').html(info);
				jQuery('.js-nickname_suggestion_plp').trigger('plp_show');
			}
			if (response[2] === 'suggestions') {
				jQuery('.js-nickname_suggestion_plp_title').html(info);
				let html = response[3] + '<br>';
				const suggestions = response[4];
				let first = true;
				for (let i in suggestions) {
					if (suggestions.hasOwnProperty(i)) {
						if (first) {
							first = false;
						} else {
							html += ', ';
						}
						html += '<span class="link_blue js-choose_nickname_suggestion">' + suggestions[i] + '</span>';
					}
				}
				jQuery('.js-nickname_suggestion_plp_text').html(html);
				jQuery('.js-choose_nickname_suggestion').on('click', choose_nickname_suggestion);
				jQuery('.js-nickname_suggestion_plp').trigger('plp_show');
			} else if (info) {
				if (yalwa.v.is_standalone) {
					info = yalwa.v.lang.missing_fname_lname_nickname;
					reset_tabs();
				}
				yalwa.basics.toast({message: info, type: 'warning'});
			}
		}
	}

	function choose_nickname_suggestion() {
		jQuery('.js-profile_nickname').val(jQuery(this).text());
		jQuery('.js-activate_submit').prop('disabled', false);
		jQuery('.js-nickname_suggestion_plp').trigger('plp_hide', {is_queued:true});
		settings_save();
	}

	function geolocation_profile_address(lat, lon) {
		yalwa.basics.maps.suggestions(lat, lon).done(function(data) {
			if (data && data.places && data.places[0] && data.places[0].value) {
				jQuery('[name="mapCity"]').val(data.places[0].value).trigger('input');
			}
		});
	}

	function init_notifications_settings() {
		
		jQuery('.js-notification_center__tabs_item').on('click', function(e) {
			const $this = jQuery(this);
			const url = $this.data('href');			
			if ($this.data('site')) {
				yalwa.basics.set_get({'site': $this.data('site')}, false, false);
			}
			if ($this.data('filter')) {
				yalwa.basics.set_get({'filter': $this.data('filter')}, false, false);
			}
			jQuery.ajax({
				url: url,
				type: 'get',				
			}).done((response) => {
				const $response = jQuery(response);
				jQuery('.js-plp_container').html('');
				$response.find('.js-plp').each(function() {
					jQuery(this).removeClass('js-detach_body');
					const html = jQuery(this).prop('outerHTML');
					jQuery('.js-plp_container').append(html);
					jQuery(this).remove();					
				})
				if ($response.find('.js-notification_center_site').length) {
					jQuery('.js-notification_center_site').html($response.find('.js-notification_center_site').html());
				}
				if ($response.find('.js-notification_center__tabs').length) {
					jQuery('.js-notification_center__tabs').html($response.find('.js-notification_center__tabs').html());
				}
				if ($response.find('.js-notification_center__header_mobile').length) {
					jQuery('.js-notification_center__header_mobile').html($response.find('.js-notification_center__header_mobile').html());
				}
				init_notifications_settings();
				yalwa.abos_mobile.init();

			});
		});
		
		jQuery('.js-manage_abo_input').on('change', function() {
			const $this = jQuery(this);			
			if ($this.prop('nodeName') != 'INPUT') {
				return false;
			}
			let type = $this.data('type') == 'push' ? 'push' : 'email';
			let event_data = {};
			event_data['event'] = $this.is(':checked') ? 're-subscribe_' + type + '_notification_centre' : 'unsubscribe_' + type + '_notification_centre';
			event_data['unsubscribe_' + type + '_category'] = $this.data('name');			
			yalwa.basics.ga.datalayer(event_data);
		});
		jQuery('.js-change_notifications_settings').on('change', function() {
			const $this = jQuery(this);
			let type = $this.data('type') == 'push' ? 'push' : 'email';
			let event_data = {};
			event_data['event'] = $this.is(':checked') ? 're-subscribe_' + type + '_notification_centre' : 'unsubscribe_' + type + '_notification_centre';
			event_data['unsubscribe_' + type + '_category'] = $this.data('name') ? $this.data('name').replace('optout_push_', '') : $this.data('name-email');
			yalwa.basics.ga.datalayer(event_data);
			
			jQuery.ajax({
				url: '/api/ajax/notification_settings/',
				type: 'post',
				data: {
					name: $this.data('name') ? $this.data('name') : $this.data('name-email'),
					action: $this.is(':checked') ? 'allow' : 'disallow',
					type: $this.data('name-email') ? 'email' : 'push'
				},
			}).done(() => {
				const $f = jQuery('.js-profile_settings_form');
				yalwa.basics.toast_success($f.data('label_success_body'));
			});
		});
		jQuery(document).on('change', '.js-unsubscribe_from_fav_posting', function() {			
			const $this = jQuery(this);
			// for favorites, its alsways email:
			let type = 'email';
			yalwa.basics.ga.datalayer({
				'event': $this.is(':checked') ? 're-subscribe_' + type + '_notification_centre' : 'unsubscribe_' + type + '_notification_centre',
				'unsubscribe_email_category': 'alert favorite ad'
			});
			jQuery.ajax({
				url: '/api/ajax/notification_settings/',
				type: 'post',
				data: {
					msgID: $this.data('msgid'),
					action: $this.is(':checked') ? 'subscribe' : 'unsubscribe'					
				},
			}).done(() => {
				const $f = jQuery('.js-profile_settings_form');
				yalwa.basics.toast_success($f.data('label_success_body'));
			});
		});	

		if (jQuery('#sentinel').length) {
			document.addEventListener('DOMContentLoaded', function() {
				const sentinel = document.getElementById('sentinel');
				const notificationInfoBox = document.getElementById('notification_info_box');
	
				const observer = new IntersectionObserver(
					([entry]) => {
						notificationInfoBox.classList.toggle('sticky');
					},
					{ threshold: [0] }
				);
	
				observer.observe(sentinel);
			});
		}
		
		
	}
	
	pub.show_example_page_toaster = function(label) {
		yalwa.basics.toast({message: label, type: 'success'});
	}

	return pub;

})(yalwa.accounts);

yalwa.accounts.init();
